/* Coffao — home V3 : récit au scroll + sachet 3D. JavaScript simple, aucune dépendance à compiler. */
(function(){
  var root=document.getElementById('cfh3'); if(!root)return;
  var chapters=[].slice.call(root.querySelectorAll('.h3-ch'));
  var dots=[].slice.call(root.querySelectorAll('.h3-dots i'));
  var reduce=window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* apparitions + compteur */
  [].forEach.call(root.querySelectorAll('.h3-ch h1,.h3-ch h2'),function(h){var n=0;h.classList.add('h3-split');
    h.innerHTML=h.textContent.trim().split(/\s+/).map(function(w){return '<span class="h3-w"><span style="--i:'+(n++)+'">'+w+'</span></span>';}).join(' ');});
  var counted=false;
  var io=new IntersectionObserver(function(es){es.forEach(function(e){
    if(!e.isIntersecting){if(!reduce&&e.target.dataset.i!=='0')e.target.classList.remove('h3-in');return;} e.target.classList.add('h3-in');
    if(e.target.dataset.i==='1'&&!counted){counted=true;var el=document.getElementById('cfh3-cpt'),t0=performance.now();
      (function tick(now){var k=Math.min(1,(now-t0)/1400);el.textContent=Math.round(80*(1-Math.pow(1-k,3)))+(k===1?'+':'');if(k<1)requestAnimationFrame(tick);})(t0);}
  });},{threshold:.22});
  chapters.forEach(function(c){io.observe(c);});
  

  /* progression fractionnaire entre chapitres */
  function progress(){
    var mid=window.scrollY+window.innerHeight/2, cs=chapters.map(function(c){return c.offsetTop+c.offsetHeight/2;});
    if(mid<=cs[0])return 0;
    for(var i=0;i<cs.length-1;i++){if(mid<cs[i+1])return i+(mid-cs[i])/(cs[i+1]-cs[i]);}
    return (cs.length-1)+(mid-cs[cs.length-1])/window.innerHeight;
  }
  function setActive(p){var a=Math.max(0,Math.min(5,Math.round(p)));root.dataset.ch=a;
    dots.forEach(function(d,i){d.classList.toggle('h3-on',i===a);});
    root.querySelector('.h3-dots').style.opacity=p>5.4?0:1;}

  var canvas=document.getElementById('cfh3-scene');
  window.addEventListener('scroll',function(){setActive(progress());},{passive:true});
  var ok=(function(){try{var c=document.createElement('canvas');return !!(c.getContext('webgl')||c.getContext('experimental-webgl'));}catch(e){return false;}})();
  if(!ok||!root.dataset.three){canvas.style.display='none';return;}
  /* la librairie 3D (600 Ko) est chargée après le reste de la page, jamais avant le contenu */
  var sc=document.createElement('script');sc.src=root.dataset.three;sc.async=true;sc.onload=start3D;sc.onerror=function(){canvas.style.display='none';};
  (window.requestIdleCallback||function(f){setTimeout(f,300);})(function(){document.head.appendChild(sc);});
  function start3D(){

  var T=THREE, renderer=new T.WebGLRenderer({canvas:canvas,alpha:true,antialias:true});
  renderer.setPixelRatio(Math.min(window.devicePixelRatio||1,2));
  renderer.outputEncoding=T.sRGBEncoding;
  var scene=new T.Scene(), cam=new T.PerspectiveCamera(32,1,.1,60); cam.position.set(0,0,10);
  scene.add(new T.HemisphereLight(0xffffff,0xe9d9c0,.95));
  var sun=new T.DirectionalLight(0xffffff,.75); sun.position.set(3,5,6); scene.add(sun);

  /* textures dessinées au canvas : aucune image à charger */
  function tex(draw){var c=document.createElement('canvas');c.width=1024;c.height=1536;draw(c.getContext('2d'),c.width,c.height);
    var t=new T.CanvasTexture(c);t.encoding=T.sRGBEncoding;t.anisotropy=renderer.capabilities.getMaxAnisotropy();return t;}
  function seal(g,w,col){g.fillStyle=col;g.fillRect(0,0,w,150);g.strokeStyle='rgba(13,18,12,.18)';g.lineWidth=3;
    for(var y=30;y<140;y+=22){g.beginPath();g.moveTo(0,y);g.lineTo(w,y);g.stroke();}}
  function front(g,w,h){
    g.fillStyle='#F6D049';g.fillRect(0,0,w,h);
    g.fillStyle='#148441';g.beginPath();g.moveTo(0,h);g.lineTo(0,h*.72);g.bezierCurveTo(w*.25,h*.60,w*.45,h*.80,w*.62,h*.70);g.bezierCurveTo(w*.8,h*.60,w*.9,h*.66,w,h*.62);g.lineTo(w,h);g.fill();
    g.strokeStyle='#054F05';g.lineWidth=34;g.lineCap='round';g.beginPath();g.moveTo(w*.95,h*.98);g.lineTo(w*.42,h*.78);g.stroke();
    g.beginPath();g.moveTo(w*.70,h*.885);g.quadraticCurveTo(w*.62,h*.95,w*.50,h*.96);g.stroke();
    g.beginPath();g.moveTo(w*.60,h*.845);g.quadraticCurveTo(w*.66,h*.78,w*.78,h*.76);g.stroke();
    g.fillStyle='#DB4625';[[.16,.80,.10],[.30,.90,.09],[.10,.95,.08]].forEach(function(c){g.beginPath();g.arc(w*c[0],h*c[1],w*c[2],0,7);g.fill();});
    seal(g,w,'#E9BE35');
    g.textAlign='center';g.fillStyle='#148441';g.save();g.translate(w/2,h*.36);g.rotate(-.07);
    g.font="230px 'Lilita One','Arial Black',sans-serif";g.fillText('Coffao!',0,0);g.restore();
    g.fillStyle='#DB4625';g.font="64px 'Lilita One','Arial Black',sans-serif";g.fillText('TA BOÎTE DE CAFÉ',w/2,h*.44);
    g.fillStyle='#0D120C';g.font="700 40px 'DM Sans',sans-serif";g.fillText('CAFÉ DE SPÉCIALITÉ · EN GRAINS',w/2,h*.53);
    g.strokeStyle='#0D120C';g.lineWidth=5;g.beginPath();g.arc(w*.82,h*.19,74,0,7);g.stroke();
    g.font="52px 'Lilita One',sans-serif";g.fillText('80+',w*.82,h*.19+4);g.font="700 22px 'DM Sans',sans-serif";g.fillText('SCA',w*.82,h*.19+36);
  }
  function back(g,w,h){
    g.fillStyle='#F6D049';g.fillRect(0,0,w,h);seal(g,w,'#E9BE35');
    var x=110,y=300,cw=w-220,chh=880;g.fillStyle='#FFFAF4';g.beginPath();
    var r=36;g.moveTo(x+r,y);g.arcTo(x+cw,y,x+cw,y+chh,r);g.arcTo(x+cw,y+chh,x,y+chh,r);g.arcTo(x,y+chh,x,y,r);g.arcTo(x,y,x+cw,y,r);g.fill();
    g.textAlign='left';g.fillStyle='#DB4625';g.font="700 30px 'DM Sans',sans-serif";g.fillText('EXEMPLE D’ÉTIQUETTE',x+50,y+80);
    g.fillStyle='#054F05';g.font="66px 'Lilita One',sans-serif";g.fillText('Hibiscus, thé noir',x+50,y+170);g.fillText('et abricot',x+50,y+245);
    var rows=[['Origine','Pays, région, ferme'],['Variété','Type de caféier'],['Process','Lavé'],['Altitude','En mètres'],['Torréfié','En France']];
    rows.forEach(function(rw,i){var yy=y+350+i*100;g.strokeStyle='rgba(13,18,12,.2)';g.lineWidth=3;g.beginPath();g.moveTo(x+50,yy-52);g.lineTo(x+cw-50,yy-52);g.stroke();
      g.fillStyle='#0D120C';g.font="700 36px 'DM Sans',sans-serif";g.textAlign='left';g.fillText(rw[0],x+50,yy);
      g.font="500 36px 'DM Sans',sans-serif";g.textAlign='right';g.fillText(rw[1],x+cw-50,yy);});
    g.textAlign='center';g.fillStyle='#148441';g.font="90px 'Lilita One',sans-serif";g.fillText('Sip!',w/2,h*.90);
  }

  /* sachet : boîte subdivisée puis déformée (soufflet en bas, soudure en haut, coutures sur les côtés) */
  function ss(a,b,x){x=Math.max(0,Math.min(1,(x-a)/(b-a)));return x*x*(3-2*x);}
  var W=2,H=3,D=.9, geo=new T.BoxGeometry(W,H,D,20,30,10), pos=geo.attributes.position;
  for(var i=0;i<pos.count;i++){
    var x=pos.getX(i),y=pos.getY(i),z=pos.getZ(i),t=(y+H/2)/H,e=Math.abs(x)/(W/2);
    var prof=(1-ss(.70,.9,t)*.96)*(.86+.14*ss(0,.12,t));
    var pinch=1-.82*Math.pow(e,2.6)*ss(.02,.3,t);
    var puff=Math.sin(Math.PI*Math.min(1,t/.86))*.1*(1-e*e)*(1-ss(.72,.9,t));
    z=z*prof*pinch+(z>0?1:z<0?-1:0)*puff*(Math.abs(z)/(D/2));
    x=x*(1+.035*Math.sin(Math.PI*t));
    pos.setXYZ(i,x,y,z);
  }
  geo.computeVertexNormals();
  var side=new T.MeshStandardMaterial({color:0xE9BE35,roughness:.8});
  var mF=new T.MeshStandardMaterial({color:0xF6D049,roughness:.72}), mB=new T.MeshStandardMaterial({color:0xF6D049,roughness:.72});
  var bag=new T.Mesh(geo,[side,side,side,side,mF,mB]); var rig=new T.Group(); rig.add(bag); scene.add(rig);
  function paint(){mF.map=tex(front);mB.map=tex(back);mF.color.set(0xffffff);mB.color.set(0xffffff);mF.needsUpdate=mB.needsUpdate=true;}
  paint(); if(document.fonts&&document.fonts.load){Promise.all([document.fonts.load("200px 'Lilita One'"),document.fonts.load("700 40px 'DM Sans'")]).then(paint).catch(function(){});}

  /* grains et cerises qui flottent en parallaxe */
  var bits=[], beanG=new T.SphereGeometry(1,20,14), grooveG=new T.SphereGeometry(1,10,8);
  var beanM=new T.MeshStandardMaterial({color:0x4A2912,roughness:.6}), grooveM=new T.MeshStandardMaterial({color:0x3A200D,roughness:.8});
  var cherryM=new T.MeshStandardMaterial({color:0xDB4625,roughness:.45});
  function rnd(a,b){return a+Math.random()*(b-a);}
  for(var k=0;k<16;k++){
    var g=new T.Group(), cherry=k%6===5;
    if(cherry){var s=new T.Mesh(beanG,cherryM);s.scale.setScalar(.17);g.add(s);}
    else{var b=new T.Mesh(beanG,beanM);b.scale.set(.15,.1,.21);g.add(b);var gr=new T.Mesh(grooveG,grooveM);gr.scale.set(.018,.03,.19);gr.position.y=.085;g.add(gr);}
    var depth=rnd(-6,.5);
    g.userData={x:rnd(-1,1),y:rnd(-7,7),z:depth,sp:rnd(.5,1.4)*(depth>0?1.5:1),rx:rnd(-1,1),ry:rnd(-1,1),ph:rnd(0,6)};
    g.userData.k=k;g.rotation.set(rnd(0,6),rnd(0,6),rnd(0,6)); scene.add(g); bits.push(g);
  }

  /* chorégraphie : une pose par chapitre */
  var S=2.2, mobile=false;
  function poses(){return mobile?[
    {x:0,y:1.25,ry:-.4,rz:.05,s:.6},{x:0,y:1.3,ry:.5,rz:-.05,s:.56},{x:0,y:1.3,ry:Math.PI-.2,rz:.04,s:.62},
    {x:0,y:1.3,ry:Math.PI*2+.35,rz:-.07,s:.56},{x:0,y:1.3,ry:Math.PI*2-.45,rz:.06,s:.58},{x:0,y:1.2,ry:Math.PI*4,rz:0,s:.5},{x:0,y:5.5,ry:Math.PI*4.6,rz:.2,s:.4}
  ]:[
    {x:S,y:-.1,ry:-.45,rz:.06,s:1},{x:-S,y:0,ry:.55,rz:-.05,s:.94},{x:S,y:0,ry:Math.PI-.28,rz:.04,s:1.08},
    {x:-S,y:0,ry:Math.PI*2+.4,rz:-.08,s:.94},{x:S,y:0,ry:Math.PI*2-.5,rz:.06,s:1},{x:0,y:1.55,ry:Math.PI*4,rz:0,s:.5},{x:0,y:6,ry:Math.PI*4.6,rz:.2,s:.4}
  ];}
  function resize(){var w=window.innerWidth,h=window.innerHeight;renderer.setSize(w,h,false);cam.aspect=w/h;cam.updateProjectionMatrix();
    mobile=w<=820; var half=Math.tan(16*Math.PI/180)*10*cam.aspect; S=Math.min(half*.5,2.6);
    bits.forEach(function(g){g.userData.px=g.userData.x*half*(1+(-g.userData.z)*.09);});}
  window.addEventListener('resize',resize); resize();

  var cur=null, velo={}, lastY=window.scrollY, sv=0, mx=0,my=0;
  window.addEventListener('pointermove',function(e){mx=e.clientX/window.innerWidth-.5;my=e.clientY/window.innerHeight-.5;});
  function target(p){var P=poses(),i=Math.max(0,Math.min(P.length-2,Math.floor(p))),t=ss(0,1,Math.max(0,Math.min(1,p-i))),a=P[i],b=P[i+1],o={};
    for(var key in a)o[key]=a[key]+(b[key]-a[key])*t; return o;}
  function frame(now){
    var p=progress(), tg=target(Math.min(p,6)), time=now/1000;
    if(!cur||reduce){cur=tg;velo={};} else for(var key in tg){velo[key]=(velo[key]||0)+(tg[key]-cur[key])*.03;velo[key]*=.8;cur[key]+=velo[key];}
    var dy=window.scrollY-lastY;lastY=window.scrollY;sv+=(dy-sv)*.12;var tilt=reduce?0:Math.max(-.4,Math.min(.4,sv*.006));
    rig.position.set(cur.x,cur.y+(reduce?0:Math.sin(time*1.1)*.06),0);
    rig.rotation.set((reduce?0:my*.18)+tilt,cur.ry+(reduce?0:mx*.3+Math.sin(time*.7)*.04),cur.rz-tilt*.35);
    rig.scale.set(cur.s*(1-Math.abs(tilt)*.12),cur.s*(1+Math.abs(tilt)*.14),cur.s);
    var boost=1+.5*ss(3.4,4,p)*(1-ss(4.6,5.2,p)), sy=window.scrollY/window.innerHeight;
    bits.forEach(function(g){var u=g.userData,yy=u.y+sy*u.sp*1.6;yy=((yy+7)%14+14)%14-7;
      g.position.set(u.px+Math.sin(time*.4+u.ph)*.12,yy,u.z);
      if(!reduce){g.rotation.x+=.004*u.rx+.0005;g.rotation.y+=.005*u.ry;}
      g.visible=!mobile||g.userData.k<7;g.scale.setScalar(boost*(mobile?.6:1));});
    canvas.style.opacity=1-ss(5.35,5.9,p);canvas.style.visibility=p>5.95?'hidden':'visible';
    setActive(p);
    renderer.render(scene,cam);
    requestAnimationFrame(frame);
  }
  requestAnimationFrame(frame);
  }
})();
(function(){
  var root=document.getElementById('cfh3'); if(!root)return;
  if(window.matchMedia('(prefers-reduced-motion: reduce)').matches)return;
  var plain=root.querySelector('.h3-plain'),mq=root.querySelector('.h3-marquee div');
  var lastY=window.scrollY,sv=0,off=0,fine=window.matchMedia('(hover:hover) and (pointer:fine)').matches;

  (function loop(){
    var y=window.scrollY,dy=y-lastY;lastY=y;sv+=(dy-sv)*.1;
    var r=plain.getBoundingClientRect().top/window.innerHeight,k=Math.max(0,Math.min(1,1.05-r));
    plain.style.transform=k<1?'scale('+(.9+.1*k)+')':'';
    var half=mq.scrollWidth/2;off=(off+1.1+sv*.9)%half;if(off<0)off+=half;
    mq.style.transform='translateX('+(-off)+'px) skewX('+Math.max(-14,Math.min(14,-sv*.5))+'deg)';
    requestAnimationFrame(loop);
  })();
  if(!fine)return;
  [].forEach.call(root.querySelectorAll('.h3-btn'),function(b){
    b.addEventListener('pointermove',function(e){var q=b.getBoundingClientRect();
      b.style.transform='translate('+((e.clientX-q.left-q.width/2)*.28)+'px,'+((e.clientY-q.top-q.height/2)*.4)+'px)';});
    b.addEventListener('pointerleave',function(){b.style.transform='';});});
  [].forEach.call(root.querySelectorAll('.h3-card'),function(c){
    c.addEventListener('pointermove',function(e){var q=c.getBoundingClientRect(),x=(e.clientX-q.left)/q.width-.5,y=(e.clientY-q.top)/q.height-.5;
      c.style.transform='perspective(1000px) rotateY('+(x*7)+'deg) rotateX('+(-y*7)+'deg) translateY(-6px)';});
    c.addEventListener('pointerleave',function(){c.style.transform='';});});
})();
